import React, { useState } from "react";
import { ListGroup, ListGroupItem, Modal, ModalHeader, ModalBody, ModalFooter, Button } from "reactstrap";
import Dropzone from "react-dropzone";
import _ from "lodash";
import { withRouter } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import service from "../../../utils/service";
import { downloadFile } from "../../../utils/downloadFile";
import { showModal } from '../../../actions/modalActions/modalActions';
const Attachments = (props) => {
  const { attachments, is_editable, match, cb,case_status } = props;
  const case_id = _.get(match, "params.case_id", "");
  const [convertedData, setConvertedData] = useState({});
  const [ShowModal, setShowModal] = useState(false);
  const isClosed = case_status?.toLowerCase() === "closed";
  const [fileSizeError, setFileSizeError] = useState(false)
  const file = _.get(convertedData, "file");
  const fileName = _.get(convertedData, "fileName", "");
  const isVisible = useSelector((state) => state.my_profile.my_org.status);
  // const status = isVisible === "active" ? true : false
  // const dispatch = useDispatch()

  const allowedFormats = ["doc", "csv", "pdf", "docx", "xls", "xlsx"];

  const onDrop = (acceptedFiles) => {
  const selectedFile = acceptedFiles[0];
  if (!selectedFile) return;

  const fileExtension = selectedFile.name
    .split(".")
    .pop()
    .toLowerCase();

  if (!allowedFormats.includes(fileExtension)) {
    setFileSizeError(false);
    setShowModal(true);
    return;
  }

  setConvertedData({
    file: selectedFile, // store actual file object
    fileName: selectedFile.name,
  });
};


  const onCancel = () => {
    setConvertedData({});
  };



   const trgger_Download_API = async (attachment_id) => {
  try {
   let API_URL = `v4/tickets/${case_id}/attachments/${attachment_id}/download`;

    let res = await service.get(API_URL, {
      responseType: "blob",  
    });

    if (res.status === 200) {
      const contentType = res.headers["content-type"];
      const fileName =
        res.headers["content-disposition"]?.split("filename=")[1] ||
        "downloaded_file";

      downloadFile(res.data, contentType, fileName.replace(/"/g, ""));
    }
  } catch (error) {
    console.error("Download error:", error);
  }
};


  const getAttachments = () => {
    return (
      <div className="d-flex flex-wrap">
        {_.isArray(attachments) &&
          attachments.map((attachment) => {
            return (
              <div className="col-sm-6 col-md-4 col-lg-3 mb-3" key={attachment.id}>
                <div className="card">
                  <div className="card-body">
                    <div className="d-flex justify-content-between">
                      <div className="td-width">{attachment.file_name}</div>
                      <i
                        className="fa fa-download cursor-pointer fs-24"
                        onClick={() => {
                          trgger_Download_API(_.get(attachment, "id"));
                        }}
                      ></i>
                    </div>
                  </div>
                </div>
              </div>
            );
          })}
      </div>
    );
  };

const trigger_Upload = async () => {
  try {
    let API_URL = `v4/tickets/${case_id}/upload_file`;
    const formData = new FormData();
    formData.append("file", file);
    let res = await service.patch(API_URL, formData, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    });
    let success = _.get(res, "data.success");
    if (success) {
      cb();
      setConvertedData({});
    } else {
      setFileSizeError(true);
      setShowModal(true);
    }
  } catch (error) {
    console.error("Upload error:", error);
    setFileSizeError(true);
    setShowModal(true);
  }
};


  return (
    <>
      {getAttachments()}
      {is_editable && !isClosed && (
        <div className="row">
          {file && (
            <div className="mt-3 d-flex justify-content-center flex-column">
              <b className="mb-2 d-block">Dropped Files</b>
              <ListGroup>
                <ListGroupItem>{fileName}</ListGroupItem>
              </ListGroup>
              <div>
                <button
                  className="btn btn-primary mt-2 me-3"
                  onClick={() => {
                      trigger_Upload()
                  }}
                >
                  Upload
                </button>
                <button
                  className="btn btn-primary mt-2 me-3"
                  onClick={() => {
                    onCancel();
                  }}
                >
                  Delete
                </button>
              </div>
            </div>
          )}
          <div className="col-md-6 offset-md-3 mb-3">
            <div className="dropzone-wrapper dropzone-wrapper-lg rw-list">
              <Dropzone onDrop={onDrop} onFileDialogCancel={onCancel}>
                {({ getRootProps, getInputProps }) => (
                  <div {...getRootProps()}>
                    <input
                      {...getInputProps({
                        accept:
                          ".pdf, .doc, .docx, .xlsx, .xls, .csv"
                      })}
                    />
                    <div className="dropzone-content">
                      <p>
                      Drag and drop files here, or click to select files for upload. The maximum size allowed is 5 MB. 
                      </p>
                    </div>
                  </div>
                )}
              </Dropzone>
            </div>
          </div>
        </div>
      )}

      <Modal isOpen={ShowModal} toggle={() => setShowModal(!ShowModal)}>
        <ModalHeader>Upload Error</ModalHeader>
        <ModalBody>
          {fileSizeError
            ? "File size is too large!"
            : "Files are not in the allowed format. Allowed formats are .pdf, .doc, .docx, .xlsx, .xls, .csv"
          }
        </ModalBody>

        <ModalFooter>
          <Button color="primary" onClick={() => setShowModal(false)}>
            OK
          </Button>
        </ModalFooter>
      </Modal>
    </>
  );
};

export default withRouter(Attachments);
